import { Checkbox, FormControlLabel } from '@mui/material'
import _, { type PropertyPath } from 'lodash'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import type { PropertyStringPath, SearchFilterState } from '../../types'

type Props = {
  label: string
  fieldPath: PropertyStringPath<SearchFilterState> & PropertyPath
}
export const FilterSingleCheckbox = (props: Props) => {
  const { selectors, updateNext } = useSearch()
  const nextSearchOptions = useAppSelector(selectors.selectNextSearchParameters)

  const checked = !!_.get(nextSearchOptions, props.fieldPath)

  const handleChange = () => {
    updateNext(_.set({}, props.fieldPath, !checked))
  }

  return (
    <FormControlLabel
      label={props.label}
      control={<Checkbox />}
      checked={checked}
      onChange={handleChange}
    />
  )
}
